import {
  useEffect,
  useMemo,
  useState
} from 'react'

import {
  DEFALUT_PER_PAGE,
  DEFAULT_PAGE,
  DEVICE_UUID,
  PERIOD_MONTH_FUTURE_MAGAZINE
} from 'configs/constant'
import { SEARCH } from 'configs/path'
import { useAppSelector } from 'hooks'
import { IBook } from 'models/book'
import {
  useLocation,
  useSearchParams
} from 'react-router-dom'
import {
  apiGetMagazineDigital,
  getAllMagazinePurchase
} from 'services/magazineService'
import { bindParams } from 'utilities/helpers'
import { notifyError } from 'utilities/notification'

export const useMagazine = () => {
  const { app_id } = useAppSelector((s) => s.app)
  const [magazinesPuchase, setMagazinesPuchase] = useState<IBook[]>([])
  const [magazineDigital, setMagazinesDigital] = useState<IBook[]>([])

  const [pagePuchase, setPagePuchase] = useState(DEFAULT_PAGE)
  const [pageDigital, setPageDigital] = useState(DEFAULT_PAGE)

  const [totalPuchase, setTotalPuchase] = useState(-1)
  const [totalDigital, setTotalDigital] = useState(-1)

  const [isGotDigital, setIsGotDigital] = useState(false)
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const [query] = useSearchParams()
  const hasMore = useMemo(() => {
    if (!isGotDigital) {
      return magazineDigital.length < totalDigital
    } else {
      return magazinesPuchase.length < totalPuchase
    }
    // return magazinesPuchase.length + magazineDigital.length < totalPuchase + totalDigital && !isGotPuchase
  }, [magazinesPuchase.length, magazineDigital.length, totalPuchase, totalDigital, isGotDigital])

  const search_header = useMemo(() => {
    if (
      decodeURIComponentSafely(location.pathname) !==
      bindParams(SEARCH, {
        app: app_id
      })
    ) {
      return ''
    }
    return query.get('keyword') ? decodeURIComponentSafely(query.get('keyword') || '') : ''
  }, [location.search])

  function decodeURIComponentSafely(uri: string) {
    try {
      return decodeURIComponent(uri)
    } catch (e) {
      return uri
    }
  }

  const getMagazineDigital = async (currentPage = pageDigital) => {
    setLoading(true)
    try {
      const response = await apiGetMagazineDigital({
        is_get_future_magazine: 1,
        period_month: PERIOD_MONTH_FUTURE_MAGAZINE,
        device_token: localStorage.getItem(DEVICE_UUID) || '',
        per_page: DEFALUT_PER_PAGE,
        page: currentPage,
        app_id,
        ...(search_header.length ? { keyword: search_header } : {}),
        ...!!query.get('typeSearch') ? { search_pdf: query.get('typeSearch') } : {}
      })

      const dataList = response.data.list.map((item: IBook) => {
        return {
          ...item,
          is_purchased: 0
        }
      })

      if (currentPage === DEFAULT_PAGE) {
        setMagazinesDigital(dataList)
      } else {
        setMagazinesDigital(magazineDigital.concat(dataList))
      }
      setIsGotDigital(dataList.length + magazineDigital.length === response.data.total)
      setTotalDigital(response.data.total)
      setLoading(false)
    } catch (e) {
      notifyError({ message: 'Error' })
    }
  }

  const getMagazinesPurchase = async (currentPage = pagePuchase) => {
    setLoading(true)
    try {
      const response = await getAllMagazinePurchase({
        per_page: DEFALUT_PER_PAGE,
        page: currentPage,
        app_id,
        ...(search_header.length ? { keyword: search_header } : {}),
        ...!!query.get('typeSearch') ? { search_pdf: query.get('typeSearch') } : {}
      })
      const dataList = response.data.list.map((item: IBook) => {
        return {
          ...item,
          is_purchased: 1,
          isDisplay: magazineDigital.findIndex((magazine) => magazine.id === item.id) === -1
        }
      })
      if (currentPage === DEFAULT_PAGE) {
        setMagazinesPuchase(dataList)
      } else {
        setMagazinesPuchase(magazinesPuchase.concat(dataList))
      }
      setTotalPuchase(response.data.total)
      setLoading(false)
    } catch (e) {
      notifyError({ message: 'Error' })
    }
  }

  const loadMoreDigital = () => {
    if (hasMore && !loading) {
      setPageDigital(pageDigital + 1)
      getMagazineDigital(pageDigital + 1)
    }
  }

  const loadMorePuchase = () => {
    if (hasMore && !loading) {
      setPagePuchase(pagePuchase + 1)
      getMagazinesPurchase(pagePuchase + 1)
    }
  }

  const loadMore = () => {
    if (!isGotDigital) {
      return loadMoreDigital()
    } else {
      return loadMorePuchase()
    }
  }

  useEffect(() => {
    getMagazineDigital()
  }, [search_header])

  useEffect(() => {
    if (isGotDigital) {
      getMagazinesPurchase()
    }
  }, [isGotDigital, search_header])

  return { magazinesPuchase, loadMore, hasMore, loading, search_header, magazineDigital, decodeURIComponentSafely }
}
